import React from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Col, Row, Form, Spinner, Container, Image } from "react-bootstrap";
import { useAuth } from "./useAuth"; 
import Logobajaj from "../../images/assets/logo_desarrollo1.png";
import "./css/login.css";

function Index() {
  const {
    usuario, setUsuario,
    password, setPassword,
    email, setEmail,
    isLoading,
    showModal, setShowModal,
    imagenBackground, logo,
    handleLogin
  } = useAuth();

  const bgImage = imagenBackground || "https://firebasestorage.googleapis.com/v0/b/proyecto-bajaj.appspot.com/o/Empresas%2Fparametros%2F1%2Fbackground?alt=media&token=3c058bfd-7058-4b23-971e-a08a357090f4";
  const logoImage = logo || "https://firebasestorage.googleapis.com/v0/b/proyecto-bajaj.appspot.com/o/Predeterminados%2Flogo_bajaj.jpeg?alt=media&token=e4b90edf-f176-41e2-b684-948efcd0faf6";

  return (
    <div className="login-wrapper" style={{ backgroundImage: `url(${bgImage})` }}>
      
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Recuperar contraseña</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Correo electrónico:</Form.Label>
            <Form.Control
              type="email"
              placeholder="Ingrese su correo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="modern-input"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" style={{ backgroundColor: 'var(--primary, #0056b3)', border: 'none' }}>
            Enviar Instrucciones
          </Button>
          <Button variant="light" onClick={() => { setShowModal(false); setEmail(""); }}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      <Container className="d-flex justify-content-center align-items-center min-vh-100 position-relative z-index-2">
        <Row className="w-100 justify-content-center">
          <Col xs={11} sm={8} md={6} lg={4} className="login-card">
            
            <div className="text-center mb-4">
              <Image src={logoImage} alt="Logo" fluid className="login-logo" />
            </div>

            <Form onSubmit={handleLogin}>
              {/* Adaptación a Bootstrap 4 manteniendo el estilo moderno */}
              <Form.Group controlId="formUsuario" className="mb-3">
                <Form.Control
                  type="email"
                  placeholder="Usuario o Correo"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  required
                  className="modern-input"
                />
              </Form.Group>

              <Form.Group controlId="formPassword" className="mb-4">
                <Form.Control
                  type="password"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="modern-input"
                />
              </Form.Group>
              
              <Button 
                type="submit" 
                className="w-100 login-btn" 
                disabled={isLoading}
              >
                {isLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Iniciar Sesión"}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <Link onClick={() => setShowModal(true)} to="#" className="login-recover">
                ¿Olvidaste tu contraseña?
              </Link>
            </div>

            <div className="text-center mt-4 pt-3 border-top opacity-75" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
              <Image
                src={Logobajaj}
                alt="Tecnociclo Logo"
                height="30"
                className="cursor-pointer logo-footer"
                onClick={() => window.open("http://www.tecnocyclo.com/division-industrial.php", "_blank")}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Index;